import { render } from "./AppNotificator.vue?vue&type=template&id=31c7b7ac"
import script from "./AppNotificator.vue?vue&type=script&lang=js"
export * from "./AppNotificator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__